import { init } from './MallCPA13';
init();
